<template>
	<div class="header-nav">
		<ContentPad>
			<div class="header-block">
				<div
					v-for="(tab, index) in list"
					:key="index"
					class="nav-font"
					:class="{
						'nav-font--current': isCurrentPage(tab),
						'nav-font--other': !isCurrentPage(tab)
					}"
					@click="handleNavClick(tab, index)"
				>
					<i v-if="index" class="iconfont icon-flip-right"></i>
					<span>{{ formattedNavTitle(tab) }}</span>
				</div>
			</div>
		</ContentPad>
	</div>
</template>

<script setup>
import { getCurrentInstance, computed } from 'vue';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import { useRouter } from '@/utils/vue-api';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { useHistoryNav } from '@rebuild/hooks/comp/useHistoryNav';
import { useCurrentContext } from './context';

const props = defineProps({
	list: {
		type: Array,
		default: () => []
	}
});

const context = useCurrentContext();
const formattedNavTitle = computed(() => context.formattedNavTitle);

const vm = getCurrentInstance();
const router = useRouter();

const { isCurrentPage } = useHistoryNav();

const { replaceHome } = useNavigation();
const handleNavClick = (record, index) => {
	if (record.isCurrent) return;
	if (index === 0 && record.patched) {
		replaceHome();
		return;
	}
	const backSteps = props.list.length - 1 - index;
	if (backSteps > 0) {
		const before = vm.proxy.$router.currentRoute.fullPath;
		router.go(-backSteps);
		setTimeout(() => {
			const after = vm.proxy.$router.currentRoute.fullPath;
			if (before === after) {
				// 导航回退无效，兜底跳首页
				replaceHome();
			}
		}, 200);
	}
};
</script>

<style lang="less" scoped>
.header-nav {
	background: #f7f8fa;

	.header-block {
		display: flex;
		height: 62px;
	}

	.nav-font {
		font-size: 14px;

		font-weight: 400;
		display: flex;
		align-items: center;
		position: relative;
		cursor: pointer;

		&--current {
			font-weight: 500;
			color: #1d2129;
			cursor: default;
		}
		&--other {
			color: #86909c;

			&:hover {
				color: #1d2129;
			}
		}
		.iconfont {
			margin: 0 3px;
			font-size: 16px;
			color: #e5e6e8;
		}
	}
}
</style>
